/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Hyunsu Sim (hssim@rsupport.com)
 *
 * @description
 *
 * @created at Fri Jun 02 2023
 **/

import { useAtom } from "jotai";
import { useEffect } from "react";

import { BlockUsers, Friends, SearchValue } from "./atom";
import { useBlock, useFriend } from "@/frameworks/core/API";

export default function useFriendUser() {
	const friendAPI = useFriend({
		onSuccess(name, result) {
			if (name === "friends") {
				setFriends(result.data || []);
			}
		}
	});
	const blockAPI = useBlock({
		onSuccess(name, result) {
			if (name === "list") {
				setBlockUsers(result.data || []);
			}
		}
	});
	const [searchValue] = useAtom(SearchValue);
	const [friends, setFriends] = useAtom(Friends);
	const [blockUsers, setBlockUsers] = useAtom(BlockUsers);

	useEffect(() => {
		friendAPI.friends.execute();
		blockAPI.list.execute();
	}, []);

	const handleMatchData = (data: WebServices.Friend.Friends.Data | WebServices.Block.List.Data) => {
		return data?.filter((item) => {
			if (item.username.indexOf(searchValue) !== -1) return true;
			else if (item.name.indexOf(searchValue) !== -1) return true;
			else false;
		});
	};

	return {
		friends,
		blockUsers,
		handlers: {
			handleMatchData
		}
	};
}
